import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, useNavigate } from 'react-router-dom'
import { Badge, Button, Divider, Layout, Menu, MenuProps } from 'antd'
import { appConfig } from 'config'
import {
  ShopOutlined,
  HighlightOutlined,
  ShoppingOutlined,
  EditOutlined,
  CheckSquareOutlined,
  ShoppingCartOutlined,
  PieChartOutlined,
  DesktopOutlined,
  FileSearchOutlined,
  SettingOutlined,
  ShareAltOutlined,
  CrownOutlined,
  TeamOutlined,
  FileTextOutlined,
  BankOutlined,
  FileZipOutlined,
  ApiOutlined,
  RedoOutlined,
  PicRightOutlined,
  PrinterOutlined,
  UserOutlined,
  GiftOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  MailOutlined,
  AppstoreOutlined,
  PieChartFilled,
  ShopFilled,
  ShoppingFilled,
  CrownFilled,
} from '@ant-design/icons'
import { VscTag } from 'react-icons/vsc'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { connect } from 'react-redux'
import { MyTheme } from 'Components/common/Theme'
import RootState from 'typings/RootState'
import { selectCurrentUser } from 'Store/user/selector'
import LogoImage from 'Components/logo/LogoImage'
import { getStaffPermission, getUserLogin } from 'helpers/account'
import { selectNewOrder } from 'Store/orders/selector'
import { selectIsPackageC } from 'Store/pos/selector'
import { selectCountData } from 'Store/stock/selector'
import { uniqueId } from 'lodash'
import { Theme } from 'Components/common'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { FcComboChart } from 'react-icons/fc'
import { VscDashboard } from 'react-icons/vsc'
import {
  BsPersonFill,
  BsBucketFill,
  BsBagFill,
  BsCartCheckFill,
  BsCartXFill,
  BsClockFill,
  BsFillTagsFill,
  BsTagFill,
  BsTagsFill,
  BsBootstrapFill,
  BsDatabaseFill,
  BsFileEarmarkFontFill,
  BsDatabaseFillGear,
  BsBank2,
  BsFileBarGraphFill,
  BsFillTabletFill,
  BsFilePlusFill,
  BsFileEarmarkArrowDownFill,
  BsFileEarmarkArrowUpFill,
  BsGiftFill,
  BsFillGearFill,
  BsDatabaseFillLock,
  BsFillPersonBadgeFill,
} from 'react-icons/bs'

const { Sider } = Layout
const { SubMenu } = Menu

type AppProps = {
  selected: string
}

type Props = AppProps & ReduxProps & DispatchProps

const SideMenu: React.FunctionComponent<Props> = props => {
  const { selected = '', user, newOrder, currentUser, stockNotice } = props
  const [collapsed, setCollapsed] = useState<boolean>(false)
  const [lg, setLg] = useState<boolean>(true)
  const breakpoint = useBreakpoint()
  console.log('breakpoint', breakpoint)
  const userInfo = getUserLogin()
  const isMerchant = userInfo && userInfo?.store_type === 'merchant'
  const isMock = false
  const permission = getStaffPermission()
  console.log('lg', lg)
  const isSupperAdmin = user?.activeMerchant?.id === parseInt(appConfig.merchantID || '')
  const count = newOrder?.total || 0
  const isFranchise = currentUser?.activeMerchant?.is_fc === true
  const navigate = useNavigate()

  const configMenu = [
    {
      name: 'แดชบอร์ด',
      to: '/dashboard',
      icon: <PieChartFilled />,
      subMenu: [],
      key: 'dashboard',
    },
    {
      name: 'INSEE MiniRMX',
      to: '/dashboard-rmx',
      icon: <PieChartFilled />,
      subMenu: [],
      key: 'dashboard-rmx',
    },
    {
      name: 'INSEE MiniRMX',
      to: '/dashboard-rmx-overall',
      icon: <PieChartFilled />,
      subMenu: [],
      key: 'dashboard-rmx-overall',
    },
    {
      name: 'พันธมิตรทางธุรกิจ',
      icon: <BsPersonFill />,
      to: '/merchants',
      key: 'merchants',
      showOnlySupperAdmin: true,
      subMenu: true,
      // subMenu: [
      //   {
      //     name: 'พันธมิตรทางธุรกิจ',
      //     to: '/merchants',
      //     key: 'merchants',
      //     showOnlySupperAdmin: true,
      //   },
      //   {
      //     name: 'จัดการเครื่อง POS',
      //     to: '/pos-mornitoring',
      //     key: 'pos-mornitoring',
      //     showOnlySupperAdmin: true,
      //   },
      // ],
    },
    // {
    //   name: 'ข้อมูลร้านค้า',
    //   to: '/merchant-profile',
    //   icon: <ShopOutlined />,
    //   subMenu: [],
    //   key: 'merchant-profile',
    // },
    {
      name: 'รายการสินค้า',
      to: '/products',
      icon: <BsBagFill />,
      key: 'products',
      subMenu: [],
    },
    {
      name: (
        <>
          รายการขาย <Badge count={count} showZero={false}></Badge>
        </>
      ),
      to: '/orders',
      icon: <BsCartCheckFill />,
      key: 'orders',
      subMenu: [],
    },
    {
      name: 'รายการรับคืนสินค้า',
      to: '/order-returns',
      icon: <BsCartXFill />,
      showOnlyC: true,
      subMenu: [],
      key: 'order-returns',
    },
    {
      name: 'รายการอนุมัติสินค้า',
      to: '/products-request',
      key: 'products-request',
      showOnlySupperAdmin: true,
      icon: <BsClockFill />,
      subMenu: [],
    },
    {
      name: 'จัดการแคมเปญคูปอง',
      to: '/coupons',
      icon: <BsTagsFill />,
      subMenu: [],
      key: 'coupons',
      showOnlySupperAdmin: true,
    },
    {
      name: 'จัดการคะแนนสะสม',
      to: '/point',
      icon: <CrownFilled />,
      subMenu: [],
      key: 'point',
      showOnlySupperAdmin: true,
    },
    // {
    //   name: 'จัดการแบนเนอร์',
    //   to: '/banners',
    //   icon: <HighlightOutlined />,
    //   subMenu: [],
    //   key: 'banners',
    //   showOnlySupperAdmin: true,
    // },
    {
      name: 'จัดการแบบเนอร์',
      to: '/',
      icon: <BsBootstrapFill />,
      key: 'banner',
      showOnlySupperAdmin: true,
      subMenu: [
        {
          name: 'ไฮไลต์แบนเนอร์',
          to: '/banners',
          key: 'banners',
          showOnlySupperAdmin: true,
        },
        {
          name: 'โฆษณา Ads หน้าแรก',
          to: '/ads',
          key: 'ads',
          showOnlySupperAdmin: false,
        },
      ],
    },

    {
      name: 'จัดการข้อมูล',
      to: '/',
      icon: <BsDatabaseFill />,
      key: 'setting',
      showOnlySupperAdmin: true,
      subMenu: [
        {
          name: 'หมวดหมู่สินค้า',
          to: '/categories',
          key: 'categories',
        },
        {
          name: 'ผู้ผลิต',
          to: '/manufacturers',
          key: 'manufacturers',
        },
        {
          name: 'ผลิตภัณฑ์ต่อหน่วย',
          to: '/uoms',
          key: 'uoms',
        },
        {
          name: 'คอนเท้นต์',
          to: '/contents',
          key: 'contents',
        },
      ],
    },
    {
      name: 'ใบกำกับภาษีเต็มรูปแบบ',
      to: '/tax',
      icon: <BsFileEarmarkFontFill />,
      subMenu: [],
      key: 'tax',
    },
    {
      //name: 'รายงานสินค้าคงคลัง',
      name: (
        <>
          สินค้าคงคลัง <Badge count={stockNotice?.qty || 0} showZero={false} overflowCount={999}></Badge>
        </>
      ),
      to: '/stock',
      icon: <BsBank2 />,
      subMenu: [],
      key: 'stock',
      showOnlyC: true,
    },
    {
      name: 'รายงาน',
      to: '/reports',
      icon: <BsFileBarGraphFill />,
      subMenu: [],
      key: 'reports',
      showOnlyC: true,
    },
    {
      name: 'ระบบขายหน้าร้าน',
      icon: <BsFillPersonBadgeFill />,
      subMenu: [
        {
          name: 'ระบบขายหน้าร้าน',
          to: '/pos',
          key: 'pos',
          showOnlySupperAdmin: false,
        },
        {
          name: 'จัดการเครื่อง Terminal',
          to: '/pos-mornitoring',
          key: 'pos-mornitoring',
          showOnlySupperAdmin: true,
        },
        {
          name: 'ช่องทางการชำระเงิน',
          to: '/pos-payment-config',
          key: 'pos-payment-config',
          showOnlySupperAdmin: false,
        },
      ],
    },
    {
      name: 'ระบบจัดซื้อ',
      icon: <BsFileEarmarkArrowDownFill />,
      showOnlyC: true,
      subMenu: [
        {
          name: 'ใบสั่งซื้อสินค้า',
          to: '/purchase',
          key: 'purchase',
        },
        !isFranchise && {
          name: 'รับสินค้าเข้าคลัง',
          to: '/pick-up',
          key: 'pick-up',
        },
        {
          name: 'จ่ายหนี้',
          to: '/grn',
          key: 'grn',
        },
        // {
        //   name: 'คลังสินค้า',
        //   to: '/stock',
        //   key: 'stock',
        // },
        {
          name: 'บริษัท/Supplier',
          to: '/supplier',
          key: 'supplier',
        },
        {
          name: 'ตั้งค่าข้อมูลระบบจัดซื้อ',
          to: '/purchase-setting',
          key: 'purchase-setting',
        },

        // {
        //   name: 'ใบกำกับภาษีเต็มรูปแบบ',
        //   to: '/tax',
        //   key: 'tax',
        // },
      ],
    },
    {
      name: 'ระบบขายราคาพิเศษ',
      icon: <BsFileEarmarkArrowUpFill />,
      showOnlyC: true,
      subMenu: [
        {
          name: 'ใบเสนอราคา',
          to: '/quotation',
          key: 'quotation',
        },
        {
          name: 'รายการขาย',
          to: '/supplier-order',
          key: 'supplier-order',
        },
        {
          name: 'เรียกเก็บหนี้',
          to: '/supplier-invoice',
          key: 'supplier-invoice',
        },
        {
          name: 'ใบแจ้งหนี้/ใบวางบิล',
          to: '/supplier-billing-note',
          key: 'supplier-billing-note',
        },
        {
          name: 'ลูกค้า/คู่ค้า',
          to: '/customers',
          key: 'customers',
        },
      ],
    },
    // {
    //   name: 'ตั้งค่าการพิมพ์เอกสาร',
    //   to: '/document-config',
    //   key: 'document-config',
    //   icon: <PrinterOutlined />,
    //   subMenu: [],
    // },
    // {
    //   name: 'จัดการค่าขนส่ง',
    //   to: '/delivery-costs',
    //   key: 'delivery-costs',
    //   icon: <SettingOutlined />,
    //   subMenu: [],
    // },
    {
      name: 'คะแนน/ของรางวัล',
      icon: <BsGiftFill />,
      subMenu: [
        {
          name: 'จัดการสมาชิก',
          to: '/point-member',
          key: 'point-member',
        },
        {
          name: 'การสะสมคะแนน/แลกของรางวัล',
          to: '/point-redeem',
          key: 'point-redeem',
        },
        {
          name: 'จัดการของรางวัล',
          to: '/point-reward',
          key: 'point-reward',
        },
        {
          name: 'ตั้งค่าการสะสมคะแนน',
          to: '/point-config',
          key: 'point-config',
        },
      ],
    },
    {
      name: 'ตั้งค่า',
      icon: <BsFillGearFill />,
      subMenu: [
        {
          name: 'ตั้งค่าค่าขนส่ง',
          to: '/delivery-costs',
          key: 'delivery-costs',
        },
        {
          name: 'ตั้งค่าการพิมพ์เอกสาร',
          to: '/document-config',
          key: 'document-config',
        },
        {
          name: 'แจ้งเตือนสต๊อกขั้นต่ำ',
          to: '/stock-config',
          key: 'stock-config',
        },
      ],
    },
    {
      name: 'จัดการ Permission',
      icon: <BsDatabaseFillLock />,
      to: '/manage-permission',
      key: 'manage-permission',
      showOnlySupperAdmin: true,
    },
  ] as MenuInterface[]

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  useEffect(() => {
    if (!lg) {
      setCollapsed(true)
    } else {
      setCollapsed(false)
    }
  }, [lg])

  useEffect(() => {
    if (breakpoint?.lg !== undefined) {
      setLg(breakpoint?.lg)
    } else {
      setLg(true)
    }
  }, [breakpoint])

  const onCollapse = (collapsed: boolean): void => {
    setCollapsed(collapsed)
  }

  type MenuItem = Required<MenuProps>['items'][number]

  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem
  }

  const items: MenuItem[] = [
    getItem('Navigation One', 'sub1', <MailOutlined />, [
      getItem('Item 1', null, null, [getItem('Option 1', '1'), getItem('Option 2', '2')], 'group'),
      getItem('Item 2', null, null, [getItem('Option 3', '3'), getItem('Option 4', '4')], 'group'),
    ]),

    getItem('Navigation Two', 'sub2', <AppstoreOutlined />, [
      getItem('Option 5', '5'),
      getItem('Option 6', '6'),
      getItem('Submenu', 'sub3', null, [getItem('Option 7', '7'), getItem('Option 8', '8')]),
    ]),
  ]

  const getMenuItems = (): MenuItem[] => {
    const menus = [] as MenuItem[]
    configMenu.forEach((menu: MenuInterface) => {
      if (menu.showOnlySupperAdmin && !isSupperAdmin) return
      if (menu.showOnlyOther && isSupperAdmin) return
      const hasSubmenu = menu.subMenu && menu.subMenu.length > 0
      let hasChildSub = false
      let subMenus = [] as MenuItem[]
      if (hasSubmenu) {
        menu.subMenu.forEach((subMenu: SubMenuInterface) => {
          if (permission && permission.includes(subMenu.to)) {
            hasChildSub = true
          }
          if (permission && permission.includes(subMenu.to)) {
            subMenus.push(getItem(<a href={subMenu.to}>{subMenu.name}</a>, subMenu.key))
          }
        })
        let menuItems: MenuItem = getItem(menu.name, menu.key, menu.icon, subMenus)

        menus.push(menuItems)
      } else {
        if (permission && permission.includes(menu.to)) {
          let menuItems: MenuItem = getItem(menu.name, menu.key, menu.icon)
          menus.push(menuItems)
        }
      }

      // const sub = (
      //   <SubMenu key={menu?.key || uniqueId()} title={menu.name}>
      //     {menu.subMenu.map((subMenu: SubMenuInterface) => {
      //       if (permission && permission.includes(subMenu.to)) {
      //         hasChildSub = true
      //       }
      //       return permission && permission.includes(subMenu.to) ? (
      //         <Menu.Item
      //           key={subMenu.key}
      //           onClick={() => {
      //             navigate(subMenu.to)
      //           }}
      //         >
      //           {subMenu.name}
      //           {/* <Link to={subMenu.to}>{subMenu.name}</Link> */}
      //         </Menu.Item>
      //       ) : (
      //         <span></span>
      //       )
      //     })}
      //   </SubMenu>
      // )
    })
    return menus
  }

  const onClick: MenuProps['onClick'] = e => {
    e?.domEvent?.stopPropagation()
    console.log('click', e)
    navigate(`/${e.key}`)
  }

  const slideMenu = (
    <Menu
      mode="vertical"
      theme="light"
      // defaultSelectedKeys={[]}
      // defaultOpenKeys={[]}
      style={{ height: '100%', borderRight: 0 }}
      selectedKeys={[selected]}
    >
      <LogoSection>
        <Link to="/">
          <LogoImage primaryColor={false} shortLogo={collapsed} width={collapsed ? 60 : 150} />
        </Link>
      </LogoSection>
      {isMock &&
        configMenu.map((menu: MenuInterface) => {
          if (menu.showOnlySupperAdmin && !isSupperAdmin) return
          if (menu.showOnlyOther && isSupperAdmin) return
          // if (menu.showOnlyC && !isSupperAdmin && !isPackageC) return
          const hasSubmenu = menu.subMenu && menu.subMenu.length > 0
          if (hasSubmenu) {
            return (
              <SubMenu key={`${menu?.key}-mock`} title={menu.name}>
                {menu.subMenu.map((subMenu: SubMenuInterface) => {
                  if (subMenu.showOnlySupperAdmin && !isSupperAdmin) return
                  return (
                    <Menu.Item key={`${subMenu?.key}-mock`} icon={menu.icon}>
                      <Link to={subMenu.to}>{subMenu.name}</Link>
                    </Menu.Item>
                  )
                })}
              </SubMenu>
            )
          } else {
            return (
              <Menu.Item key={menu.key} icon={menu.icon}>
                <Link to={menu.to}>{menu.name}</Link>
              </Menu.Item>
            )
          }
        })}
      {!isMock &&
        configMenu.map((menu: MenuInterface) => {
          if (menu.showOnlySupperAdmin && !isSupperAdmin) return
          if (menu.showOnlyOther && isSupperAdmin) return
          //if (menu.showOnlyC && !isSupperAdmin && !isPackageC) return
          const hasSubmenu = menu.subMenu && menu.subMenu.length > 0
          let hasChildSub = false
          if (hasSubmenu) {
            const sub = (
              <SubMenu key={menu?.key || uniqueId()} title={menu.name} icon={menu.icon}>
                {menu.subMenu.map((subMenu: SubMenuInterface) => {
                  if (permission && permission.includes(subMenu.to)) {
                    hasChildSub = true
                  }
                  return permission && permission.includes(subMenu.to) ? (
                    <Menu.Item
                      key={subMenu.key}
                      onClick={() => {
                        navigate(subMenu.to)
                      }}
                      icon={menu.icon}
                    >
                      {subMenu.name}
                      {/* <Link to={subMenu.to}>{subMenu.name}</Link> */}
                    </Menu.Item>
                  ) : (
                    <span></span>
                  )
                })}
              </SubMenu>
            )
            return hasChildSub ? sub : <span></span>
          } else {
            // if (!permission.includes(menu.key)) return
            return permission && permission.includes(menu.to) ? (
              <Menu.Item
                key={menu.key}
                onClick={() => {
                  navigate(menu.to)
                }}
                icon={menu.icon}
              >
                {menu.name}
              </Menu.Item>
            ) : (
              <span></span>
            )
          }
        })}
    </Menu>
  )

  return (
    <SlideArea
      width={200}
      className="site-layout-background"
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      collapsedWidth={0}
      trigger={!lg ? collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined /> : ''}
      about={lg ? 'true' : 'false'}
    >
      {/* {slideMenu} */}
      <LogoSection>
        <Link to="/">
          <LogoImage primaryColor={false} shortLogo={collapsed} width={collapsed ? 60 : 150} />
        </Link>
      </LogoSection>
      {/* <Divider dashed style={{ backgroundColor: '#ccc', margin: '0px 0' }} />
      <MerchatName>
        <p>{user?.activeMerchant?.name || ''}</p>
      </MerchatName> */}
      <Menu
        selectedKeys={[selected]}
        onClick={onClick}
        mode="vertical"
        items={getMenuItems()}
        theme="light"
      />
    </SlideArea>
  )
}

const SlideArea = styled(Sider)`
  z-index: 10;
  background: ${(props: { theme: MyTheme }): string => props.theme.colors.backgroundGradient};
  .ant-layout-sider-trigger {
    background: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
    background: transparent;
    //border-top: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    span {
      color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    }
    text-align: right;
    width: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .ant-layout-sider-zero-width-trigger{
    top: 10px;
    display: none;
    background: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
    display: ${props => (props?.about == 'false' ? 'block' : 'none')};
  }

  .ant-menu {
    //background: ${(props: { theme: MyTheme }): string => props.theme.colors.backgroundGradient};
    background: transparent;
    border-right: none;
  }

  .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: transparent;
  }

  .ant-menu-inline-collapsed {
    width: 60px;
  }

  .ant-menu-item,
  .ant-menu-submenu {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
    color: #fff;
  }

  .ant-menu-item a,
  .ant-menu-item a:hover,
  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow,
  .ant-menu-submenu-title:hover,
  .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
  .ant-menu-submenu:active > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
    color: #fff;
  }

  .ant-menu-item-selected,
  .ant-menu-item-selected a,
  .ant-menu-submenu-selected:hover i {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary} !important;
  }

  .ant-menu-submenu-selected,
  .ant-menu-submenu-selected .ant-menu-submenu-title:hover,
  .ant-menu-submenu-selected i {
    background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  }

  .ant-menu-submenu-title {
    padding-top: 2px;
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  }

`

const LogoSection = styled.div`
  padding: 0px 0 10px 0;
  text-align: center;
  padding-top: ${props => (props?.about === 'true' ? '60px' : '20px')};
`

const MerchatName = styled.div`
  text-align: center;
  padding: 20px 5px 0px 5px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  p {
    font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    user: selectCurrentUser(state),
    newOrder: selectNewOrder(state),
    isPackageC: selectIsPackageC(state),
    currentUser: selectCurrentUser(state),
    stockNotice: selectCountData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu)
